import img from './img';
import audio from './audio';
import gameData from './gameData.config.js';

var config = {
  author: 'TR',
  engine: 'Steps',
  title: [
    {
      text: 'Czy umiesz uruchomić komputer? Kliknij w przycisk przeznaczony do włączania komputera.',
      audio: 'games/page002_game4/audio/z2c4.mp3',
    },
  ],
  gameConfig: gameData,
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

// console.log( 'config', config );
export default config;
